export const isInDevelopment =
  import.meta.env.VITE_ENVIRONMENT === 'dev' || import.meta.env.VITE_ENVIRONMENT === 'stg';

export const GA_CONFIG = {
  gaMeasurementId: '',
  gtmContainerId: 'GTM-T8RBCTTX'
};

// Adding an event here is not enough for it to reach GA4: the GTM Platform container
// (GTM-T8RBCTTX) only forwards names its whitelist trigger matches, and GA4 itself rejects
// anything outside [A-Za-z][A-Za-z0-9_]{0,39}. Both rules are enforced by
// __tests__/eventNames.test.js — see gtmWhitelist.js for the mirrored regex, and the
// "Event Naming Convention" runbook:
// https://transact-digital.atlassian.net/wiki/spaces/Resources/pages/456458242/Event+Naming+Convention
export const GA_EVENTS = {
  // 6.1 Signup form
  sign_up_step_1: 'sign_up_step_1',
  sign_up_step_2: 'sign_up_step_2',
  // 2.1 Login
  login: 'login',
  // 2.2 Start Page pageview
  pageview_start_page: 'pageview_start_page',
  // 3. Fund Creation
  pageview_fund_create: 'pageview_fund_create',
  fund_create_Information_complete: 'fund_create_Information_complete',
  fund_create_GeoIndustries_complete: 'fund_create_GeoIndustries_complete',
  fund_create_financials_complete: 'fund_create_financials_complete',
  fund_create_transaction_complete: 'fund_create_transaction_complete',
  fund_create_valuation_complete: 'fund_create_valuation_complete',
  fund_create_complete: 'fund_create_complete',
  // 4. Portfolio Company Form
  pageview_portfolio_co_create: 'pageview_portfolio_co_create',
  portfolio_co_information_complete: 'portfolio_co_information_complete',
  portfolio_co_geoindustries_complete: 'portfolio_co_geoindustries_complete',
  portfolio_co_financials_complete: 'portfolio_co_financials_complete',
  portfolio_co_transaction_complete: 'portfolio_co_transaction_complete',
  portfolio_co_valuation_complete: 'portfolio_co_valuation_complete',
  portfolio_co_create_complete: 'portfolio_co_create_complete',
  // company profile creation
  company_create_page_view: 'getting_started',
  complete_company_profile: 'complete_company_profile',
  // 5.1 Search download
  download_search: 'download_search',
  // 5.2 Outreach Company/Fund
  outreach_search: 'outreach_search',
  // 6.1 Signup form
  //
  //
  pageview_invest_profile_create: 'pageview_invest_profile_create',

  // Auth flow
  sign_up_submitted: 'sign_up_submitted',
  sign_up_completed: 'sign_up_completed',
  sign_up_failed: 'sign_up_failed',
  login_failed: 'login_failed',
  logout: 'logout',
  password_reset_requested: 'password_reset_requested', // NOSONAR (S2068): GA4 event name, not a credential

  // Onboarding / activation funnel
  onboarding_step_pending: 'onboarding_step_pending',
  onboarding_company_profile_completed: 'onboarding_company_profile_completed',
  onboarding_user_account_completed: 'onboarding_user_account_completed',
  activation: 'activation',

  // Search / Profiler
  search_tab_switched: 'search_tab_switched',
  search_type_changed: 'search_type_changed',
  search_advanced_expanded: 'search_advanced_expanded',
  search_executed: 'search_executed',
  search_results_displayed: 'search_results_displayed',
  search_result_clicked: 'search_result_clicked',

  // Company Detail
  company_profile_viewed: 'company_profile_viewed',
  company_tab_changed: 'company_tab_changed',
  company_action_clicked: 'company_action_clicked',

  // Watchlist
  watchlist_viewed: 'watchlist_viewed',
  watchlist_item_added: 'watchlist_item_added',
  watchlist_item_removed: 'watchlist_item_removed',
  watchlist_check_updates_clicked: 'watchlist_check_updates_clicked',

  // Projects
  projects_viewed: 'projects_viewed',
  project_tab_changed: 'project_tab_changed',
  project_view_details_clicked: 'project_view_details_clicked',
  project_re_executed: 'project_re_executed',
  project_archived: 'project_archived',
  project_restored: 'project_restored',
  project_deleted: 'project_deleted',
  project_created: 'project_created',

  // Agentic AI
  agentic_ai_opened: 'agentic_ai_opened',
  agentic_ai_quick_action_clicked: 'agentic_ai_quick_action_clicked',
  agentic_ai_message_sent: 'agentic_ai_message_sent',
  agentic_ai_response_received: 'agentic_ai_response_received',
  agentic_ai_new_chat: 'agentic_ai_new_chat',
  agentic_ai_conversation_opened: 'agentic_ai_conversation_opened',
  agentic_ai_conversation_favorited: 'agentic_ai_conversation_favorited',
  agentic_ai_conversation_archived: 'agentic_ai_conversation_archived',
  agentic_ai_quota_exhausted: 'agentic_ai_quota_exhausted',

  // Team
  team_page_viewed: 'team_page_viewed',
  team_tab_changed: 'team_tab_changed',
  team_request_shared: 'team_request_shared',
  team_feedback_submitted: 'team_feedback_submitted',
  team_request_resolved: 'team_request_resolved',

  // Outreach
  outreach_started: 'outreach_started',
  outreach_message_sent: 'outreach_message_sent',

  // Agent message controls (TD-2345 / TD-2346 / TD-2347)
  message_copy_user_message: 'message_copy_user_message',
  message_rerun_clicked: 'message_rerun_clicked',
  message_stop_clicked: 'message_stop_clicked',

  // Agent contact enrichment (TD-2293) — metadata-only bags; NEVER revealed values
  agent_enrichment_options_shown: 'agent_enrichment_options_shown',
  agent_enrichment_option_selected: 'agent_enrichment_option_selected',
  agent_enrichment_reveal_confirm_shown: 'agent_enrichment_reveal_confirm_shown',
  agent_enrichment_reveal_confirmed: 'agent_enrichment_reveal_confirmed',
  agent_enrichment_reveal_cancelled: 'agent_enrichment_reveal_cancelled',
  agent_enrichment_reveal_job_started: 'agent_enrichment_reveal_job_started',
  agent_enrichment_reveal_job_completed: 'agent_enrichment_reveal_job_completed'
};

export const GA_DIMENSIONS = {
  testMode: 'testMode',
  debug_mode: 'debug_mode',
  debug_event: 'debug_event',
  traffic_type: 'traffic_type',
  ecommerce: 'ecommerce',
  method: 'method',
  user_id: 'user_id',
  user_company_type: 'user_company_type',
  cType: 'cType',
  funds: 'funds',
  portfolio_companies: 'portfolio_companies',
  fund_name: 'fund_name',
  Fund_vintage: 'Fund_vintage',
  Fund_Volume: 'Fund_Volume',
  Geographies: 'Geographies',
  Industries: 'Industries',
  Revenue_Range_min: 'Revenue_Range_min',
  Revenue_Range_max: 'Revenue_Range_max',
  EBITDA_min: 'EBITDA_min',
  EBITDA_max: 'EBITDA_max',
  EBITDA_margin: 'EBITDA_margin',
  EBIT_min: 'EBIT_min',
  EBIT_max: 'EBIT_max',
  EBIT_margin: 'EBIT_margin',
  Situation: 'Situation',
  Equity_Stake: 'Equity_Stake',
  Enterprise_VR_min: 'Enterprise_VR_min',
  Enterprise_VR_max: 'Enterprise_VR_max',
  Equity_VR_min: 'Equity_VR_min',
  Equity_VR_max: 'Equity_VR_max',
  portfolio_co_name: 'portfolio_co_name',
  portfolio_company_revenue: 'portfolio_company_revenue',
  portfolio_company_EBITDA: 'portfolio_company_EBITDA',
  portfolio_company_description: 'portfolio_company_description',
  geographies: 'geographies',
  industries: 'industries',
  revenue_range_min: 'revenue_range_min',
  revenue_range_max: 'revenue_range_max',
  EBITDA_range_min: 'EBITDA_range_min',
  EBITDA_range_max: 'EBITDA_range_max',
  EBIT_range_min: 'EBIT_range_min',
  EBIT_range_max: 'EBIT_range_max',
  situation: 'situation',
  equity_stake: 'equity_stake',
  enterprise_value_range_min: 'enterprise_value_range_min',
  enterprise_value_range_max: 'enterprise_value_range_max',
  equity_value_range_min: 'equity_value_range_min',
  equity_value_range_max: 'equity_value_range_max',
  company_type: 'company_type',
  Country: 'Country',
  Tagline: 'Tagline'
};
